import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { CriarSenhaTemporariaService } from './criar-senha-temporaria.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

@Component({
  selector: 'ngx-criar-senha-temporaria',
  templateUrl: './criar-senha-temporaria.component.html',
  styleUrls: ['./criar-senha-temporaria.component.scss']
})
export class CriarSenhaTemporariaComponent implements OnInit {

  public formCriarSenhaTemporaria = null;
  public confirmarSenha = null;
  public senha = null;
  public listDominio = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private service: CriarSenhaTemporariaService,
    private location: Location,
    private notificationService: NotificationsService,
    private spinnerService: NgxSpinnerService,

  ) {

    this.listDominio = [

      {
        dominio: 'USUARIO_TERCEIRO',
        descricao: 'Usuário Terceiro'
      },

      {
        dominio: 'EMPRESA',
        descricao: 'Empresa'
      },

      {
        dominio: 'APP_USUARIO_PF',
        descricao: 'App Usuário PF'
      },

      {
        dominio: 'APP_USUARIO_PJ',
        descricao: 'App Cliente PJ'
      },

    ];

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom)

    this.formCriarSenhaTemporaria = this.formBuilder.group({
      login: [null],
      cliente: [null],
      senha: [null],
      dominio: [null],
      data: [null],

    });


  }

  gotoBuscar(data) {

    let register = {

      domain: data.dominio,
      login: data.login

    }

    if ((data.login === null) || (data.dominio === null)) {
      this.notificationService.error("Campo Login e Domínio são obrigatório !!!");

    } else {

      this.spinnerService.show();

      this.service.returnClient(register, (response => {

        this.formCriarSenhaTemporaria.controls['cliente'].setValue(response.razaoSocial);
        this.spinnerService.hide();

      }), error => {

        this.spinnerService.hide();
        this.notificationService.error(error.message);

      });

    }

  }

  gotoGerar(data) {

    let register = {

      domain: data.dominio,
      login: data.login

    }

    if ((data.login === null) || (data.dominio === null)) {

      this.notificationService.error("Campo Login e Domínio são obrigatório !!!");

    } else if ((data.cliente === null)) {

      this.notificationService.error("Necessário identificar o Cliente !!!");

    } else {

      this.spinnerService.show();

      this.service.newTemporaryPassword(register, (response => {

        let expiracaoTemporaria = moment(response.expiracaoTemporaria).format('DD/MM/YYYY HH:mm');

        this.formCriarSenhaTemporaria.controls['data'].setValue(expiracaoTemporaria);
        this.formCriarSenhaTemporaria.controls['senha'].setValue(response.senhaTemporaria);

        this.spinnerService.hide();
      }), error => {

        this.spinnerService.hide();
        this.notificationService.error(error.message);

      });

    }

  }


  previousPage() {

    this.location.back();

  }

  gotoVoltar() {

    this.location.back();

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
